import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);

export const dictionaries = {
    es: {
        nav: {
            inicio: "Inicio",
            nosotros: "Nosotros",
            habitaciones: "Alojamientos",
            resenas: "Reseñas",
            contacto: "Contacto",
            reservar: "Reservar",
            home: "Ir al inicio — Hotel Punta Palmeras",
            open: "Abrir menú",
            close: "Cerrar menú",
            language: "Idioma",
        },
        hero: {
            location: "Punta Pérula · Jalisco · México",
            brand: "Hotel Punta Palmeras",
            titleA: "Conecta con el mar",
            titleB: "y la naturaleza",
            sub: "Habitaciones, bungalows y suites a una cuadra de la playa, con alberca y terraza, en plena Costalegre, Jalisco.",
            cta1: "Reservar ahora",
            cta2: "Conocer el hotel",
            scroll: "Desliza",
            barAria: "Consulta de disponibilidad",
            checkin: "Entrada",
            checkout: "Salida",
            adults: "Adultos",
            children: "Niños",
            dates: "Fechas",
            guests: "Personas",
            addDates: "Llegada — Salida",
            guestSummary: (a, c) => `${a} adulto${a === 1 ? "" : "s"}${c > 0 ? ` · ${c} niño${c === 1 ? "" : "s"}` : ""}`,
            consult: "Consultar",
        },
        marquee: [
            "A una cuadra de la playa",
            "Alberca y terraza",
            "Habitaciones, bungalows y suites",
            "Punta Pérula, Costalegre",
            "Bahía de Chamela, Jalisco",
        ],
        welcome: {
            number: "01",
            label: "Bienvenido",
            titleA: "Tu hotel en Punta Pérula,",
            titleEm: "a una cuadra",
            titleB: "de la playa",
            p1a: "Hotel Punta Palmeras es un hotel familiar en",
            p1em: "Punta Pérula",
            p1b: ", un pueblo pesquero de la bahía de Chamela, en la Costalegre de Jalisco. Estamos a una cuadra de la playa y del malecón, y tenemos habitaciones, bungalows y suites con aire acondicionado, wifi, TV inteligente y baño completo.",
            p2: "Aquí las mañanas huelen a mar y los atardeceres se ven desde la terraza. Camina a la arena en dos minutos, date un chapuzón en la alberca y déjate llevar por el ritmo tranquilo de la Costalegre.",
            highlights: [
                "A 1 cuadra de la playa y el malecón",
                "7 tipos de habitación, bungalow y suite",
                "Alberca y terraza entre palmeras",
            ],
            imgAlt: "Fachada de Hotel Punta Palmeras entre palmeras",
        },
        amenities: {
            aria: "Amenidades del hotel",
            items: ["Estacionamiento", "Internet / Wifi", "Alberca", "Playa cerca", "Terraza", "Restaurante"],
        },
        rooms: {
            number: "02",
            label: "Habitaciones & Suites",
            titleA: "Habitaciones y suites",
            titleEm: "en Punta Pérula",
            titleB: "",
            intro: "Habitaciones, bungalows y suites con aire acondicionado, wifi, TV inteligente y baño completo — a una cuadra de la playa, en la Costalegre de Jalisco.",
            verMas: "Ver más",
        },
        reviews: {
            number: "03",
            label: "Reseñas",
            titleA: "Lo que dicen nuestros",
            titleEm: "huéspedes",
            titleB: "",
            basedOn: "Basado en reseñas verificadas de",
            google: "Google",
            verified: "Huésped verificado",
            avgAria: "Calificación promedio 4.5 de 5",
        },
        visit: {
            number: "04",
            label: "Visítanos",
            titleA: "A una cuadra del",
            titleEm: "Pacífico",
            titleB: "",
            name: "Nombre",
            email: "Correo electrónico",
            message: "Mensaje",
            send: "Enviar mensaje",
            mapTitle: "Mapa: Hotel Punta Palmeras, Av. Independencia No. 6, Punta Pérula, Jalisco",
        },
        footer: {
            tagline: "Hotel familiar a una cuadra de la playa en Punta Pérula, Costalegre, Jalisco. Alberca, terraza y descanso de verdad.",
            quick: "Enlaces rápidos",
            policiesTitle: "Políticas de reservación",
            policies: [
                "Check-in 3:00 pm · Check-out 12:00 pm",
                "Cancelación sin costo hasta 24 h antes de la llegada",
                "Se requiere identificación oficial al registrarse",
                "Mascotas: consultar disponibilidad",
            ],
            rights: "© 2026 Hotel Punta Palmeras · Punta Pérula, Jalisco, México",
        },
        booking: {
            title: "Reserva tu estancia",
            checkin: "Entrada",
            checkout: "Salida",
            adults: "Adultos",
            children: "Niños",
            dates: "Fechas",
            guests: "Personas",
            addDates: "Llegada — Salida",
            guestSummary: (a, c) => `${a} adulto${a === 1 ? "" : "s"}${c > 0 ? ` · ${c} niño${c === 1 ? "" : "s"}` : ""}`,
            submit: "Solicitar reservación",
        },
        roomPage: {
            back: "Todos los alojamientos",
            details: "Ficha de la habitación",
            capacity: "Capacidad",
            beds: "Camas",
            amenitiesTitle: "Amenidades incluidas",
            beachPerk: "A una cuadra de la playa y el malecón",
            galleryAria: "Galería de la habitación",
            viewImage: "Ver imagen",
        },
        whatsapp: "Contactar por WhatsApp",
        stays: {
            title: "Alojamientos en Punta Pérula, Costalegre | Hotel Punta Palmeras",
            desc: "Habitaciones, bungalows y suites de Hotel Punta Palmeras en Punta Pérula, Costalegre, Jalisco: A/C, wifi, TV inteligente y baño completo, a una cuadra de la playa.",
            label: "Alojamientos",
            titleA: "Todos nuestros",
            titleEm: "alojamientos",
            intro: "Habitaciones, bungalows y suites con aire acondicionado, wifi, TV inteligente y baño completo — a una cuadra de la playa y el malecón.",
        },
        policies: {
            title: "Políticas de reservación, cancelación y reembolso | Hotel Punta Palmeras",
            desc: "Políticas de reservación, cancelación y reembolso de Hotel Punta Palmeras en Punta Pérula, Jalisco: check-in, cancelaciones sin costo y reembolsos.",
            label: "Políticas",
            heading: "Políticas de reservación, cancelación y reembolso",
            sections: [
                { h: "Reservaciones", p: "Toda reservación queda confirmada al recibir el anticipo o la confirmación por nuestro motor de reservas. Al registrarse se requiere identificación oficial y tarjeta o depósito para cargos extras. Check-in a partir de las 3:00 pm y check-out hasta las 12:00 pm." },
                { h: "Cancelaciones", p: "Puedes cancelar sin costo hasta 24 horas antes de tu fecha de llegada. Las cancelaciones fuera de ese plazo o la no presentación (no show) generan el cargo de la primera noche." },
                { h: "Reembolsos", p: "Los reembolsos aplicables se procesan al mismo método de pago en un plazo de 7 a 10 días hábiles. En temporada alta, días festivos o tarifas promocionales pueden aplicar condiciones especiales que se informan al momento de reservar." },
                { h: "Modificaciones", p: "Cambios de fecha o de tipo de habitación están sujetos a disponibilidad. Escríbenos por WhatsApp o correo con tu número de reservación y con gusto te ayudamos." },
                { h: "Mascotas y otras políticas", p: "Las mascotas se aceptan previa consulta de disponibilidad. No está permitido fumar dentro de las habitaciones. Cualquier daño a la habitación o al mobiliario se carga a la cuenta del huésped responsable." },
            ],
        },
        survey: {
            title: "Encuesta de satisfacción | Hotel Punta Palmeras",
            desc: "Cuéntanos cómo fue tu estancia en Hotel Punta Palmeras, Punta Pérula. Tu opinión nos ayuda a mejorar cada visita.",
            label: "Encuesta",
            heading: "¿Cómo fue tu estancia?",
            intro: "Tu opinión nos ayuda a mejorar. Toma menos de un minuto.",
            name: "Nombre",
            email: "Correo electrónico",
            room: "Habitación en la que te hospedaste",
            rating: "Calificación general",
            comments: "Cuéntanos más (opcional)",
            send: "Enviar encuesta",
            thanks: "¡Gracias por tu opinión!",
            thanksSub: "Nos encantará recibirte de nuevo en Punta Pérula.",
        },
        seo: {
            homeTitle: "Hotel en Punta Pérula, Costalegre | Hotel Punta Palmeras — habitaciones y suites cerca de la playa",
            homeDesc: "Hotel Punta Palmeras: hotel familiar en Punta Pérula, bahía de Chamela, en la Costalegre. Habitaciones, bungalows y suites con A/C, wifi, alberca y terraza, a una cuadra de la playa y el malecón.",
            roomSuffix: " | Hotel Punta Palmeras — Punta Pérula, Jalisco",
            roomDesc: "{name} en Hotel Punta Palmeras, Punta Pérula, Costalegre, Jalisco: {capacity}, {beds}. Wifi, TV inteligente, A/C y baño completo. A una cuadra de la playa.",
            notFoundTitle: "Habitación no encontrada | Hotel Punta Palmeras",
            notFoundDesc: "La habitación que buscas no existe.",
        },
    },
    en: {
        nav: {
            inicio: "Home",
            nosotros: "About",
            habitaciones: "Accommodations",
            resenas: "Reviews",
            contacto: "Contact",
            reservar: "Book Now",
            home: "Go to home — Hotel Punta Palmeras",
            open: "Open menu",
            close: "Close menu",
            language: "Language",
        },
        hero: {
            location: "Punta Pérula · Jalisco · Mexico",
            brand: "Hotel Punta Palmeras",
            titleA: "Connect with the sea",
            titleB: "and nature",
            sub: "Rooms, bungalows and suites one block from the beach, with a pool and terrace, right on the Costalegre coast.",
            cta1: "Book now",
            cta2: "Discover the hotel",
            scroll: "Scroll",
            barAria: "Availability check",
            checkin: "Check-in",
            checkout: "Check-out",
            adults: "Adults",
            children: "Children",
            dates: "Dates",
            guests: "Guests",
            addDates: "Check-in — Check-out",
            guestSummary: (a, c) => `${a} adult${a === 1 ? "" : "s"}${c > 0 ? ` · ${c} ${c === 1 ? "child" : "children"}` : ""}`,
            consult: "Check rates",
        },
        marquee: [
            "One block from the beach",
            "Pool & terrace",
            "Rooms, bungalows & suites",
            "Punta Pérula, Costalegre",
            "Chamela Bay, Jalisco",
        ],
        welcome: {
            number: "01",
            label: "Welcome",
            titleA: "Your hotel in Punta Pérula,",
            titleEm: "one block",
            titleB: "from the beach",
            p1a: "Hotel Punta Palmeras is a family-run hotel in",
            p1em: "Punta Pérula",
            p1b: ", a fishing village on Chamela Bay, on the Costalegre coast of Jalisco. We are one block from the beach and the boardwalk, with rooms, bungalows and suites featuring air conditioning, wifi and Smart TV.",
            p2: "Mornings smell like the sea here and sunsets are best watched from the terrace. Walk to the sand in two minutes, take a dip in the pool and let the slow rhythm of the Costalegre take over.",
            highlights: [
                "1 block from the beach & boardwalk",
                "7 room, bungalow & suite types",
                "Pool & terrace among palm trees",
            ],
            imgAlt: "Hotel Punta Palmeras facade among palm trees",
        },
        amenities: {
            aria: "Hotel amenities",
            items: ["Parking", "Internet / Wifi", "Pool", "Beach nearby", "Terrace"],
        },
        rooms: {
            number: "02",
            label: "Rooms & Suites",
            titleA: "Rooms and suites",
            titleEm: "in Punta Pérula",
            titleB: "",
            intro: "Rooms, bungalows and suites with air conditioning, wifi, Smart TV and a full bathroom — one block from the beach, on the Costalegre coast.",
            verMas: "See more",
        },
        reviews: {
            number: "03",
            label: "Reviews",
            titleA: "What our",
            titleEm: "guests",
            titleB: "say",
            basedOn: "Based on verified reviews on",
            google: "Google",
            verified: "Verified guest",
            avgAria: "Average rating 4.5 out of 5",
        },
        visit: {
            number: "04",
            label: "Visit us",
            titleA: "One block from the",
            titleEm: "Pacific",
            titleB: "",
            name: "Name",
            email: "Email",
            message: "Message",
            send: "Send message",
            mapTitle: "Map: Hotel Punta Palmeras, Av. Independencia No. 6, Punta Pérula, Jalisco",
        },
        footer: {
            tagline: "Family-run hotel one block from the beach in Punta Pérula, Costalegre, Jalisco. Pool, terrace and real rest.",
            quick: "Quick links",
            policiesTitle: "Booking policies",
            policies: [
                "Check-in 3:00 pm · Check-out 12:00 pm",
                "Free cancellation up to 24 hours before arrival",
                "Official ID required at check-in",
                "Pets: ask about availability",
            ],
            rights: "© 2026 Hotel Punta Palmeras · Punta Pérula, Jalisco, Mexico",
        },
        booking: {
            title: "Book your stay",
            checkin: "Check-in",
            checkout: "Check-out",
            adults: "Adults",
            children: "Children",
            dates: "Dates",
            guests: "Guests",
            addDates: "Check-in — Check-out",
            guestSummary: (a, c) => `${a} adult${a === 1 ? "" : "s"}${c > 0 ? ` · ${c} ${c === 1 ? "child" : "children"}` : ""}`,
            submit: "Request booking",
        },
        roomPage: {
            back: "All accommodations",
            details: "Room fact sheet",
            capacity: "Capacity",
            beds: "Beds",
            amenitiesTitle: "Included amenities",
            beachPerk: "One block from the beach & boardwalk",
            galleryAria: "Room gallery",
            viewImage: "View image",
        },
        whatsapp: "Contact us on WhatsApp",
        stays: {
            title: "Accommodations in Punta Pérula, Costalegre | Hotel Punta Palmeras",
            desc: "Rooms, bungalows and suites at Hotel Punta Palmeras in Punta Pérula, Costalegre, Jalisco: A/C, wifi, Smart TV and full bathroom, one block from the beach.",
            label: "Accommodations",
            titleA: "All our",
            titleEm: "accommodations",
            intro: "Rooms, bungalows and suites with air conditioning, wifi, Smart TV and a full bathroom — one block from the beach and the boardwalk.",
        },
        policies: {
            title: "Booking, cancellation and refund policies | Hotel Punta Palmeras",
            desc: "Booking, cancellation and refund policies of Hotel Punta Palmeras in Punta Pérula, Jalisco: check-in, free cancellations and refunds.",
            label: "Policies",
            heading: "Booking, cancellation and refund policies",
            sections: [
                { h: "Bookings", p: "Every booking is confirmed once the deposit or confirmation through our booking engine is received. Official ID and a card or deposit for extras are required at check-in. Check-in from 3:00 pm and check-out until 12:00 pm." },
                { h: "Cancellations", p: "You can cancel free of charge up to 24 hours before your arrival date. Cancellations after that deadline or a no-show are charged the first night." },
                { h: "Refunds", p: "Applicable refunds are processed to the same payment method within 7 to 10 business days. High season, holidays or promotional rates may carry special conditions informed at booking time." },
                { h: "Modifications", p: "Date or room-type changes are subject to availability. Message us on WhatsApp or by email with your booking number and we will gladly help you." },
                { h: "Pets and other policies", p: "Pets are welcome upon prior availability check. Smoking is not allowed inside the rooms. Any damage to the room or furniture is charged to the responsible guest." },
            ],
        },
        survey: {
            title: "Satisfaction survey | Hotel Punta Palmeras",
            desc: "Tell us how your stay at Hotel Punta Palmeras, Punta Pérula was. Your feedback helps us improve every visit.",
            label: "Survey",
            heading: "How was your stay?",
            intro: "Your feedback helps us improve. It takes less than a minute.",
            name: "Name",
            email: "Email",
            room: "Room you stayed in",
            rating: "Overall rating",
            comments: "Tell us more (optional)",
            send: "Send survey",
            thanks: "Thank you for your feedback!",
            thanksSub: "We would love to welcome you back in Punta Pérula.",
        },
        seo: {
            homeTitle: "Hotel in Punta Pérula, Costalegre | Hotel Punta Palmeras — rooms & suites near the beach",
            homeDesc: "Hotel Punta Palmeras: family-run hotel in Punta Pérula, Chamela Bay, on the Costalegre. Rooms, bungalows and suites with A/C, wifi, pool and terrace, one block from the beach and boardwalk.",
            roomSuffix: " | Hotel Punta Palmeras — Punta Pérula, Jalisco",
            roomDesc: "{name} at Hotel Punta Palmeras, Punta Pérula, Costalegre, Jalisco: {capacity}, {beds}. Wifi, Smart TV, A/C and full bathroom. One block from the beach.",
            notFoundTitle: "Room not found | Hotel Punta Palmeras",
            notFoundDesc: "The room you are looking for does not exist.",
        },
    },
};

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            const stored = localStorage.getItem("hpp-lang");
            return stored === "en" || stored === "es" ? stored : "es";
        } catch {
            return "es";
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem("hpp-lang", lang);
        } catch {
            /* sin persistencia */
        }
        document.documentElement.lang = lang;
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, t: dictionaries[lang] }}>
            {children}
        </LanguageContext.Provider>
    );
}

export const useLang = () => useContext(LanguageContext);
